import React, { Component } from 'react';
import {ajaxWrapper, resolveVariables} from 'functions';

import {Wrapper, ListWithChildren, Container, Header, Button, Table, TableRow, TableHeader, TableData, If, Div, Image, Span, Link, Paragraph} from 'library';
import Navbar from 'projectLibrary/navbar.js';
import Footer from 'projectLibrary/footer.js';


class UserList extends Component {
    render() {

        return (<div>
			<Navbar />

			<Container order={"2"} min_height={true} >
				<Header text={"All Users"}  />
				<Button href={"/adminedituser/"} text={"Add New User"} type={"success"} style={{'margin-bottom': '20px'}}  />
				<Table >
					<TableRow >
						<TableHeader data={"Email"}  />
						<TableHeader data={"Is Staff?"}  />
						<TableHeader data={"Edit"}  />
					</TableRow>
					<ListWithChildren dataUrl={"/api/user/user/"} nowrapper={true} objectName={"user"} noDataMessage={"No Users Found"} >
						<TableRow >
							<TableData data={resolveVariables({"text":"{props.email}"}, this)["text"]}  />
							<TableData data={resolveVariables({"text":"{props.is_staff}"}, this)["text"]}  />
							<TableData >
								<Button href={resolveVariables({"text":"/adminEditUser/{props.id}/"}, this)["text"]} text={"Edit"} type={"primary"}  />
							</TableData>
						</TableRow>
					</ListWithChildren>
				</Table>
			</Container>

			<Footer />
        </div>);
    }
}
export default UserList;
